import { define, AttributesMixin, attributes, type } from "@type-r/models";
import { AssetData, AssetType } from "./assetData";
import { CommonParticipant } from "./commonParticipant";

export type BankAccount = InstanceType<typeof BankAccount>;
export const BankAccount = attributes({
    alias: String,
    uid: type(String).value('00000000-0000-0000-0000-000000000000'),
    number: String,
    name: String,
    address: String
});

export const PaymentType = attributes({
    id: Number,
    name: String,
});

export const PaymentMethod = attributes({
    id: Number,
    name: String,
});

export type DebtorBankAccount = InstanceType<typeof DebtorBankAccount>;
export const DebtorBankAccount = attributes({
    ...BankAccount.attributes,
    payor: CommonParticipant,
});

export type CreditorBankAccount = InstanceType<typeof CreditorBankAccount>;
export const CreditorBankAccount = attributes({
    ...BankAccount.attributes,
    payee: CommonParticipant,
});

@define
export class Payment extends AssetData {
    static attributes = {
        ...AssetData.attributes,
        assetType: type(AssetType).value({ id: 4, name: 'Payment' }),

        paymentType: PaymentType,
        debtorBankAccount: DebtorBankAccount,
        creditorBankAccount: CreditorBankAccount,
        referenceNumber: String,
        assetPaymentDate: type(Date).null,
        paymentAmount: Number,
        currency: String,
        originalAssetObligor: CommonParticipant,
        postedOn: type(Date).null,
        paymentDetails: String,
        lockBoxNumber: String,
        paymentMethod: PaymentMethod,
        bankEntryDate: type(Date).null,

        validationCategory: type(Number).dontSave,
    }
    isLoaded: boolean;

    get isDigitized(){
        return this.state.name == 'Digitized';
    }

    onLoaded() {
        const defaultValues = new Payment();
        this.set({ state: defaultValues.state.clone() });
        if (!this.assetType) this.set({ assetType: defaultValues.assetType.clone() });
        if (!this.paymentType) this.set({ paymentType: defaultValues.paymentType.clone() });
        if (!this.debtorBankAccount) this.set({ debtorBankAccount: defaultValues.debtorBankAccount.clone() });
        if (!this.creditorBankAccount) this.set({ creditorBankAccount: defaultValues.creditorBankAccount.clone() });
        this.isLoaded = true;
    }
}

export interface Payment extends AttributesMixin<typeof Payment> { }
